/** This component holds all the buttons and functions for the attackers selection */

import * as React from "react";
import { useState } from "react";
import Warrior from "../img/Attackers/Warrior.png";
import Archer from "../img/Attackers/Archer.png";
import Rider from "../img/Attackers/Rider.png";
import Defender from "../img/Attackers/Defender.png";
import Swordsman from "../img/Attackers/Swordsman.png";
import Catapult from "../img/Attackers/Catapult.png";
import Knight from "../img/Attackers/Knight.png";
import Giant from "../img/Attackers/Giant.png";
// import Battleship from "../img/Attackers/Battleship.png";
// import Switch from "../img/Other/Switch1.png";
// import Boat from "../img/Attackers/Boat.png";
// import Ship from "../img/Attackers/Ship.png";
import Amphibian from "../img/Attackers/Amphibian.png";
import Tridention from "../img/Attackers/Tridention.png";
import Shark from "../img/Attackers/Shark.png";
import Puffer from "../img/Attackers/Puffer.png";
import Jelly from "../img/Attackers/Jelly.png";
import Crab from "../img/Attackers/Crab.png";
import Polytaur from "../img/Attackers/Polytaur.png";
// import Navalon from "../img/Attackers/Navalon.png";
import DragonEgg from "../img/Attackers/Dragon Egg.png";
import BabyDragon from "../img/Attackers/Baby Dragon.png";
import FireDragon from "../img/Attackers/Fire Dragon.png";
import Mooni from "../img/Attackers/Mooni.png";
import IceArcher from "../img/Attackers/Ice Archer.png";
import BattleSled from "../img/Attackers/Battle Sled.png";
import IceFortress from "../img/Attackers/Ice Fortress.png";
import Gaami from "../img/Attackers/Gaami.png";
import Hexapod from "../img/Attackers/Hexapod.png";
import Kiton from "../img/Attackers/Kiton.png";
import Phychi from "../img/Attackers/Phychi.png";
import Raychi from "../img/Attackers/Raychi.png";
import Shaman from "../img/Attackers/Shaman.png";
import Exida from "../img/Attackers/Exida.png";
import Doomux from "../img/Attackers/Doomux.png";
import Centipede from "../img/Attackers/Centipede.png";
import Segment from "../img/Attackers/Segment.png";
import MindBender from "../img/Attackers/Mind Bender.png";
import NatureBunny from "../img/Attackers/Nature Bunny.png";
import Dagger from "../img/Attackers/Dagger.png";
import Dinghy from "../img/Attackers/Dinghy.png";
import Cloak from "../img/Attackers/Cloak.png";
import Pirate from "../img/Attackers/Pirate.png";
import Raft from "../img/Attackers/Raft.png";
import Scout from "../img/Attackers/Scout.png";
import Rammer from "../img/Attackers/Rammer.png";
import Bomber from "../img/Attackers/Bomber.png";
import Juggernaut from "../img/Attackers/Juggernaut.png";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CardWithShadow from "./cardWithShadow";
import { SINGLE_COL_MAX_WIDTH_PX, ONE_HUNDRED_PERCENT } from "../customStyles";

/** This property is to indicate to the parent component that a soldier needs to be added to the battleground */
type AttackerPageProps = {
    onAddAttacker: any;
    pageIndex: number;
    disabled?: boolean;
};

// Centralized styles
const attackersImageStyle = {
    height: "60px",
    width: "45px",
    objectFit: "contain",
    WebkitAppearance: "none",
} as React.CSSProperties;

const attackersBoxStyle = {
    display: "flex",
    justifyContent: "space-between",
    mb: 2,
};

const attackersButtonStyle = {
    m: 1,
    maxWidth: "6em",
    minWidth: "6em",
    height: "80px",
    padding: "10px",
};

// Updated attacker structure with page names
const attackerPages = [
    {
        name: "Regular Tribes (Imperius, etc.)",
        units: [
            { name: "Warrior", img: Warrior, flipped: true },
            { name: "Archer", img: Archer, flipped: true },
            { name: "Rider", img: Rider, flipped: true },
            { name: "Defender", img: Defender, flipped: true },
            { name: "MindBender", img: MindBender, flipped: true },
            { name: "Swordsman", img: Swordsman, flipped: true },
            { name: "Catapult", img: Catapult, flipped: true },
            { name: "Knight", img: Knight, flipped: true },
            { name: "Giant", img: Giant, flipped: true },
            { name: "Juggernaut", img: Juggernaut },
            { name: "Cloak", img: Cloak },
            { name: "Dinghy", img: Dinghy },
            { name: "Dagger", img: Dagger, flipped: true },
            { name: "Pirate", img: Pirate },
            { name: "Raft", img: Raft },
            { name: "Scout", img: Scout },
            { name: "Rammer", img: Rammer },
            { name: "Bomber", img: Bomber },
        ]
    },
    {
        name: "Elyrion",
        units: [
            { name: "Polytaur", img: Polytaur },
            { name: "DragonEgg", img: DragonEgg },
            { name: "BabyDragon", img: BabyDragon },
            { name: "FireDragon", img: FireDragon },
        ]
    },
    {
        name: "Aquarion",
        units: [
            { name: "Amphibian", img: Amphibian },
            { name: "Tridention", img: Tridention },
            { name: "Shark", img: Shark },
            { name: "Puffer", img: Puffer },
            { name: "Jelly", img: Jelly },
            { name: "Crab", img: Crab },
        ]
    },
    {
        name: "Polaris",
        units: [
            { name: "Mooni", img: Mooni },
            { name: "IceArcher", img: IceArcher },
            { name: "BattleSled", img: BattleSled },
            { name: "Gaami", img: Gaami },
            { name: "IceFortress", img: IceFortress },
        ]
    },
    {
        name: "Cymanti",
        units: [
            { name: "Hexapod", img: Hexapod },
            { name: "Kiton", img: Kiton },
            { name: "Phychi", img: Phychi },
            { name: "Raychi", img: Raychi },
            { name: "Shaman", img: Shaman },
            { name: "Exida", img: Exida },
            { name: "Doomux", img: Doomux },
            { name: "Centipede", img: Centipede },
            { name: "Segment", img: Segment },
        ]
    },

    {
        name: "Single mode",
        units: [
            { name: "NatureBunny", img: NatureBunny },           
        ]
    },
];

/**
 * Attackers rows component
 */
const AttackerPage = ({
    onAddAttacker,
    pageIndex,
    disabled = false,
}: AttackerPageProps) => {
    const attackers = attackerPages[pageIndex].units;
    const rows = Math.ceil(attackers.length / 5);

    return (
        <Box>
            {[...Array(rows)].map((_, rowIndex) => (
                <Box key={rowIndex} sx={attackersBoxStyle}>
                    {attackers.slice(rowIndex * 5, (rowIndex + 1) * 5).map((def, index) => (
                        <Button
                            key={`${def.name}-${index + (rowIndex * 5)}`}
                            onClick={() => onAddAttacker(def.name)}
                            size="small"
                            variant="outlined"
                            sx={attackersButtonStyle}
                            disabled={disabled}
                        >
                            <img
                                src={def.img}
                                alt={def.name}
                                style={{
                                    ...attackersImageStyle,
                                }}
                            />
                        </Button>
                    ))}
                </Box>
            ))}
        </Box>
    );
};

/**
 * Navigate attackers selection rows
 */
const AttackersSelection = ({
    onAddAttacker,
    disabled = false,
}: AttackerPageProps) => {
    const [currentPage, setCurrentPage] = useState(0);
    const regularTribesIndex = 0; // Index of Regular Tribes page

    const handlePageChange = (direction: "prev" | "next") => {
        if (direction === "prev") {
            setCurrentPage((prevPage) =>
                prevPage === 0 ? attackerPages.length - 1 : prevPage - 1
            );
        } else {
            setCurrentPage((prevPage) =>
                prevPage === attackerPages.length - 1 ? 0 : prevPage + 1
            );
        }
    };

    return (
        <CardWithShadow
            sx={{ p: "1%" }}
            style={{
                maxWidth: `${SINGLE_COL_MAX_WIDTH_PX}px`,
                width: ONE_HUNDRED_PERCENT,
            }}
        >
            <Typography component={"span"} variant="h6">
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => handlePageChange("prev")}
                        sx={{ m: 1 }}
                        style={{ maxWidth: "4em", minWidth: "4em" }}
                        disabled={disabled}
                    >
                        <ArrowBackIosNewIcon sx={{ fontSize: "medium" }} />
                    </Button>
                    <select 
                        value={currentPage}
                        onChange={(e) => setCurrentPage(Number(e.target.value))}
                        style={{ 
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            backgroundColor: 'white',
                            minWidth: '150px'
                        }}
                        disabled={disabled}
                    >
                        {attackerPages.map((page, index) => (
                            <option key={page.name} value={index}>
                                {page.name}
                            </option>
                        ))}
                    </select>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => handlePageChange("next")}
                        sx={{ m: 1 }}
                        style={{ maxWidth: "4em", minWidth: "4em" }}
                        disabled={disabled}
                    >
                        <ArrowForwardIosIcon sx={{ fontSize: "medium" }} />
                    </Button>
                </Box>
                <Box>
                    <AttackerPage
                        pageIndex={currentPage}
                        onAddAttacker={onAddAttacker}
                        disabled={disabled}
                    />
                </Box>
                {currentPage !== regularTribesIndex && (
                    <>
                        <Box sx={{ mt: 3, mb: 1 }}>
                            <Typography variant="h6" sx={{ textAlign: 'center' }}>
                                Regular Tribes Units
                            </Typography>
                        </Box>
                        <AttackerPage
                            pageIndex={regularTribesIndex}
                            onAddAttacker={onAddAttacker}
                            disabled={disabled}
                        />
                    </>
                )}
            </Typography>
        </CardWithShadow>
    );
};

export default AttackersSelection;
